import { List } from '@epicuro-next/models/engagement';
import { ProductSourceDetails } from '@epicuro-next/state/config-strip-state';

import { isCommercialList, isPowerList } from './is-list-of-type';

export const getListProductSourceDetails = (
  list: List,
): ProductSourceDetails => {
  return {
    listId: [list.id],
    listType: list.type?.toLowerCase(),
    isCommercial: isCommercialList(list),
    isPowerList: isPowerList(list),
  };
};
